import { BodyText, Button } from "@/components/ui";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogOverlay,
  DialogTitle,
} from "../ui/Dialog/Dialog";

interface OverrideDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onOverride: () => void;
  isLoading?: boolean;
  /** Dialog heading, derived from the blocking error(s) by the parent. */
  title: string;
  /** One bullet per blocking conflict. Empty renders no list. */
  messages?: string[];
}

/**
 * Generic confirm-to-override dialog. The parent supplies the title and the
 * per-conflict messages (see `overrideConflicts.ts`) so this component stays
 * agnostic to which block(s) triggered it.
 */
export const OverrideDialog = ({
  isOpen,
  onOpenChange,
  onOverride,
  isLoading = false,
  title,
  messages = [],
}: OverrideDialogProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogOverlay />
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        {messages.length > 0 && (
          <ul className="list-disc pl-5">
            {messages.map((message) => (
              <li key={message}>
                <BodyText tag="span">{message}</BodyText>
              </li>
            ))}
          </ul>
        )}
        <BodyText>
          To take the patient anyway, please click "Override".
        </BodyText>
        <DialogFooter>
          <Button variant="secondary" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={onOverride} isLoading={isLoading}>
            Override
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
